module.exports = __webpack_public_path__ + "media/3.a3be15c8.mp3";